import React, { useState, useEffect, useMemo, useRef, useImperativeHandle, createRef } from "react";
/* eslint-disable react-hooks/exhaustive-deps */
import { 
  useTable, useExpanded, usePagination, useSortBy, useAsyncDebounce, useGlobalFilter, useRowSelect, useRowState
} from 'react-table';

import { useSticky } from 'react-table-sticky';

import EditCell from "./editCell";
import ReactTable from "./reactTable";
import GlobalFilter from "./globalFilter";
import Pagination from "./Pagination";
import { initRowState, cellRenderCallBack } from "../teTable/utils";

const colorGroup = {
  default: {
    color: "black",           // tbody的文字颜色
    thColor: "text-gray-700", // th 表头的文字颜色
    thBgColor: "bg-gray-100", // th 表头的背景颜色
    bgColor1: "bg-gray-100",  // 奇数行的背景色
    bgColor2: "bg-white",     // 偶数行的背景色
    holdercolor: "placeholder-gray-400",
    iptBgColor: "bg-white",
    pageColor: "text-coolGray-900",
    pageSelectBgColor: "bg-white",
    nextPageBgcolor: "bg-white"
  },
  white: {
    color: "text-white",
    thColor: "text-white",
    thBgColor: "",
    bgColor1: "",
    bgColor2: "",
    holdercolor: "placeholder-white",
    iptBgColor: "bg-transparent",
    pageColor: "text-white",
    pageSelectBgColor: "bg-transparent",
    nextPageBgcolor: "bg-transparent"
  }
};


export const defaultPluginList = [
  useRowState,
  useGlobalFilter,
  useSortBy,
  useExpanded,
  usePagination,
  useRowSelect,
  useSticky
]


export const defaultTableProps = {}


const Tetable = ({ columns=[], data=[], tableProps=defaultTableProps, stateHandler=null, tablePlugins=defaultPluginList, tableInstanceRef=createRef(), ...props }) => {
  // 创建reactTable 的默认状态
  let rowState = initRowState(data, columns);

  // get reactTable instance
  const tableInstance = useTable(
    {
      columns,
      data,
      defaultColumn: { Cell: EditCell },
      initialState: { rowState: rowState },
      autoResetHiddenColumns: true,
      autoResetExpanded: false,
      ...tableProps,
    },
    ...tablePlugins,
  );

  const { 
    canPreviousPage, canNextPage, pageOptions, pageCount, gotoPage, nextPage, previousPage,
    state, setPageSize, preGlobalFilteredRows, setGlobalFilter, allColumns
  } = tableInstance;

  // 找一个能获取react-table里面的tableInstance的方法
  useImperativeHandle(tableInstanceRef, () => ({
    getInstance() {
      return tableInstance
    }
  }), [tableInstance])

  useEffect(() => {
    stateHandler && stateHandler(state, tableInstance)
  }, [state.pageSize, state.pageIndex])

  useEffect(() => {
    props.setAllColumns && props.setAllColumns(allColumns)
  }, [allColumns]);

  const tableTheme = useMemo(() => {
    if(props.customColors) {
      return props.customColors
    };
    if(props.theme) {
      return colorGroup[props.theme]
    };
    return colorGroup.default
  }, [props.theme])

  return (
    <div className="w-full h-full">
      <div>
        {<ReactTable 
          cellRenderCFn={cellRenderCallBack}
          tableTheme={tableTheme}
          tableInstance={tableInstance} 
          columns={columns} 
          data={data} 
          {...props}
        >
        </ReactTable>}
      </div>

      <div className="w-full h-20">
        {
          tableInstance.page.length > 0 && <Pagination className="mt-4"
            canPreviousPage={canPreviousPage}
            canNextPage={canNextPage}
            pageOptions={pageOptions}
            pageCount={pageCount}
            gotoPage={gotoPage}
            nextPage={nextPage}
            previousPage={previousPage}
            setPageSize={setPageSize}
            pageIndex={state.pageIndex}
            pageSize={state.pageSize}
            tableTheme={tableTheme}
          >
            {/* 全局搜索 */}
            <GlobalFilter
              tableTheme={tableTheme}
              preGlobalFilteredRows={preGlobalFilteredRows}
              globalFilter={state.globalFilter}
              setGlobalFilter={setGlobalFilter}
              useAsyncDebounce={useAsyncDebounce}
            />
          </Pagination>
        }
      </div>
    </div>
  )
};

export default Tetable;